module.exports = __webpack_public_path__ + "img/box_and_location.36634555.svg";